<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import EntitiesResource from '../../resources/entities'

export default Vue.extend({
    components: {
        AgGridVue,
    },
    props: {
        entityId: {
            required: false,
            type: [Number, String],
        },
    },
    data() {
        return {
            entitiesColumnDefs: [
                {
                    field: 'name',
                    headerName: 'name',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('name', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.name
                    },
                },
                {
                    field: 'company',
                    headerName: 'Company',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('company', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.company
                    },
                },
                {
                    field: 'parent',
                    headerName: 'Parent',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('parent', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.parent || 'No Parent Entered'
                    },
                },
                {
                    field: 'entity_type',
                    headerName: 'Entity Type',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('entity_type', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.entity_type
                    },
                },
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.id
                    },
                },
                {
                    field: 'propay_id',
                    headerName: 'ProPay Project ID#',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('propay_id', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.propay_id
                    },
                },
                {
                    field: 'probooks_url',
                    headerName: 'Probooks URL',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('probooks_url', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.probooks_url
                    },
                },
            ],
            entitiesRowData: [],
        }
    },
    computed: {
        resources() {
            return {
                EntitiesResource,
            }
        },
    },
    methods: {
        selectEntity(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },
    },

    async mounted() {
        let entitiesResources
        if (this.entityId) {
            entitiesResources = await EntitiesResource.all({ parent_id: this.entityId })
        } else {
            const entities = await EntitiesResource.list()
            entitiesResources = entities.resources
        }
        this.entitiesRowData = entitiesResources
    },
})
</script>

<template>
    <div>
        <h4>Shows/Jobs Grid</h4>
        <ag-grid-vue class="ag-theme-balham default-grid" :column-defs="entitiesColumnDefs" :row-data="entitiesRowData" @row-clicked="selectEntity" />
    </div>
</template>

<style>
@import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
